import { render, staticRenderFns } from "./RepeatProps.vue?vue&type=template&id=2556e556"
import script from "./RepeatProps.vue?vue&type=script&lang=js"
export * from "./RepeatProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports